import React from "react";
import { Avatar, Dropdown, Menu, Layout, Button, Form } from "antd";
import style from "./MainLayout.module.scss";
import { useModel } from "../../models";
import {
    MenuUnfoldOutlined,
    MenuFoldOutlined,
} from '@ant-design/icons';
import { Link } from "react-router-dom";
import { clearCache } from "../../utils/constants";
import UserOutlined from "@ant-design/icons/lib/icons/UserOutlined";
import {
    getUserInfo
} from "../../utils/constants.js";
import { loginServiceAuth2 } from "./LoginServiceAuth2";
const { Header } = Layout;

//关闭浏览器页签
export function closeWebPage() {
    if (navigator.userAgent.indexOf("MSIE") > 0) { // IE
        if (navigator.userAgent.indexOf("MSIE 6.0") > 0) {// IE6
            window.opener = null;
            window.close();
        } else {// IE6+
            window.open('', '_top');
            window.top.close();
        }
    } else if (navigator.userAgent.indexOf("Firefox") > 0 || navigator.userAgent.indexOf("Presto") > 0) {// FF和Opera
        window.location.href = 'about:blank';
        window.close();// 火狐默认状态非window.open的页面window.close是无效的
    } else {
        window.opener = null;
        window.open('', '_self', '');
        window.close();
    };
    loginServiceAuth2.recordAppLogoutInfo("scm-z", getUserInfo()?.userCode);
}

const AppHeader = () => {
    const MenuToggle = () => {
        const [{ collapsed }, { toggle }] = useModel("menuState");
        return collapsed ? <MenuUnfoldOutlined
            className={style.trigger}
            onClick={() => toggle()}
        /> : <MenuFoldOutlined
                className={style.trigger}
                onClick={() => toggle()}
            />
    }
    const HeaderMenu = () => {
        const onClearCache = () => {
            clearCache();
            window.location.reload();
        }
        return <Menu>
            <Menu.Item key="0">
                <Link to={"/"}>
                    <Button type="link" htmlType="button" onClick={() => null} className="margin-left-8">
                        个人信息
                    </Button>
                </Link>
            </Menu.Item>
            <Menu.Divider />
            <Menu.Item key="1">
                <Link to={"/"}>
                    <Button type="link" htmlType="button" onClick={() => null} className="margin-left-8">
                        角色列表
                    </Button>
                </Link>
            </Menu.Item>
            <Menu.Item key="2">
                <Button type="link" htmlType="button" onClick={onClearCache} className="margin-left-8">
                    清除缓存
                </Button>
            </Menu.Item>
            <Menu.Divider />
            <Menu.Item key="3">
                <Link to={"/"}>
                    <Button type="link" htmlType="button" onClick={() => closeWebPage()} className="margin-left-8">
                        退出
                    </Button>
                </Link>
            </Menu.Item>
        </Menu>
    };
    return <Header className={style.header} style={{ display: "flex" }}>
        <div style={{ width: "50px" }}>
            <MenuToggle />
        </div>
        <div style={{ flex: 1 }} />
        <div style={{ width: "140px" }}>
            <Dropdown overlay={HeaderMenu} trigger={['click']}>
                <span
                    className="ant-dropdown-link"
                    onClick={e => e.preventDefault()}
                    style={{ color: "#02a7f0", cursor: "pointer", fontFamily: "微软雅黑" }}
                >
                    <Avatar
                        size="small"
                        icon={<UserOutlined />}
                        style={{
                            backgroundColor: '#87d068',
                            marginBottom: "5px",
                            marginRight: "5px"
                        }}
                    />
                    {/* {userInfo.userName} */}
                    {getUserInfo()?.userName ?? ""}
                </span>
            </Dropdown>
        </div>
    </Header>
}

export default AppHeader;